var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.65 0.65H15.35V3.35H0.65V0.65Z",
    stroke: "#B59BF0",
    strokeWidth: 1.3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22801 9.35L2.85301 6.65H13.147L9.77199 9.35H6.22801Z",
    stroke: "#B59BF0",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.65,
    y: 12.65,
    width: 2.7,
    height: 2.7,
    stroke: "#B59BF0",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.aabb8ebd4a8f08dd5739eacbde3777e0.svg";
export { ForwardRef as ReactComponent };